import type { Reducer } from 'react';

export const VERIFIED_FILTER = {
  VERIFIED: 'verified',
  UNVERIFIED: 'unverified',
} as const;

export type CoachingDashboardFilterState = Readonly<{
  grades: string[];
  schools: string[];
  roleIds: number[];
  programCodes: string[];
  institutionRoles: string[];
  verified: string[];
  cohortIds: number[];
  coachIds: number[];
}>;

export type CoachingDashboardFilterAction =
  | { type: 'setGrades'; values: string[] }
  | { type: 'setSchools'; values: string[] }
  | { type: 'setRoleIds'; values: number[] }
  | { type: 'setProgramCodes'; values: string[] }
  | { type: 'setInstitutionRoles'; values: string[] }
  | { type: 'setVerified'; values: string[] }
  | { type: 'setCohortIds'; values: number[] }
  | { type: 'setCoachIds'; values: number[] }
  | { type: 'clear' };

export const initialCoachingDashboardFilters: CoachingDashboardFilterState = {
  grades: [],
  schools: [],
  roleIds: [],
  programCodes: [],
  institutionRoles: [],
  verified: [],
  cohortIds: [],
  coachIds: [],
};

export const coachingDashboardFiltersReducer: Reducer<
  CoachingDashboardFilterState,
  CoachingDashboardFilterAction
> = (state, action) => {
  switch (action.type) {
    case 'setGrades':
      return { ...state, grades: action.values };
    case 'setSchools':
      return { ...state, schools: action.values };
    case 'setRoleIds':
      return { ...state, roleIds: action.values };
    case 'setProgramCodes':
      return { ...state, programCodes: action.values };
    case 'setInstitutionRoles':
      return { ...state, institutionRoles: action.values };
    case 'setVerified':
      return { ...state, verified: action.values };
    case 'setCohortIds':
      return { ...state, cohortIds: action.values };
    case 'setCoachIds':
      return { ...state, coachIds: action.values };
    case 'clear':
      return initialCoachingDashboardFilters;
  }
};

export const hasAnyCoachingDashboardFilter = (s: CoachingDashboardFilterState): boolean =>
  s.grades.length > 0 ||
  s.schools.length > 0 ||
  s.roleIds.length > 0 ||
  s.programCodes.length > 0 ||
  s.institutionRoles.length > 0 ||
  s.verified.length > 0 ||
  s.cohortIds.length > 0 ||
  s.coachIds.length > 0;
